module.exports = __webpack_public_path__ + "static/media/PVAContainer.f8e36019.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/blocks/PVAContainer.scss
// module id = 1233
// module chunks = 0